import React, { createContext, useState, useEffect, useCallback, useContext } from 'react';
import api from '../services/api';
import AuthContext from '../context/AuthContext';

const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useContext(AuthContext);

  const fetchDashboardData = useCallback(async () => {
    // La fonction utilisera directement le 'token' du contexte.
    if (!token) return;
    setLoading(true);
    try {
      const response = await api.get('/reports/dashboard');
      setDashboardData(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données du dashboard:", error);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => {
    fetchDashboardData();
  }, [token, fetchDashboardData]);

  const value = {
    dashboardData,
    loading,
    refreshDashboard: fetchDashboardData, // Cette fonction n'a plus besoin d'argument.
  };

  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
};

export default DashboardContext;